import React, { Fragment, useEffect } from "react";
import HeadSection from "../components/solutions/HeadSection";
import MainSection from "../components/solutions/MainSection";
import Footer from "../components/footer/Footer";
import { Box, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    alignContent: "center",
    backgroundColor: theme.palette.primary.main
  },
}));

export default function Home({ setTab }) {
  useEffect(() => setTab("Solutions"), [setTab]);
  const classes = useStyles();

  return (
    <Fragment>
      <HeadSection />
      <Box className={classes.wrapper}>        
        <MainSection />
      </Box>
      <Footer />
    </Fragment>
  );
}
